<template lang="pug">
.hero
  .centered-content
    h1 
      |About budgee
    h2
      |Our story so far
    .hero-background-center
  .hero-background-color-clipped
  
  bw-wavey-bottom
</template>

<script>
import BwWaveyBottom from "@/components/shared/BwWaveyBottom";
export default {
  components: {
    BwWaveyBottom
  }
};
</script>

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl"
.centered-content
  height: 100%
  padding-top: 30px
  z-index: 3

.hero
  position: relative
  height: 700px
  h1
    margin: 0
    padding-top: 50px
    text-align: center
    font-weight: 500
    font-size: 50px
    line-height: 60px
    color: rgba(0,0,0,0.77)
    margin: 0 0 18px
  h2
    color: rgba(0,0,0,0.67)
    text-align: center
    padding-left: 3px
    line-height: 30px
    margin-bottom: 0
    font-size: 20px
    font-weight: 300
  .hero-background-color-clipped
    position: absolute
    top: 0
    left: 0
    right: 0
    width:  100%
    height: 450px
    background: #eaf1f2 //#5ac496
  .hero-background-center
    background-image: url('../../assets/images/watercolour.png')
    background-repeat: no-repeat
    background-size: contain
    position: relative
    margin: -26px auto 0
    max-width: 1200px
    width: 100%
    z-index: 2
    height: 600px
</style>
